import React from 'react';
import './Home.css';
import p1 from './goalimg.png'; // Replace with a hockey image
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
<div className="home-container">
  {/* HERO SECTION */}
  <section className="hero">
    <div className="hero-text">
      <h1>COSC 4F90 –Modeling and Explaining NHL Goal Scoring Using Machine Learning </h1>
      <p>
       A year-long independent research project modeling NHL goal scoring through large-scale shot data, statistical analysis, and machine-learning techniques to predict goal probability and explain scoring patterns.
      </p>
    </div>
    <div className="hero-image">
      <img src={p1} alt="Hockey Data Research Visualization" />
    </div>
  </section>

  {/* PROJECT OVERVIEW */}
  <section className="services">
    <div className="service-box">
      <h2>Project Roadmap & Sections</h2>
      <p>Explore each stage of the research process:</p>

      {/* PART 1 */}
      <div className="project-step">
        <h3>1️⃣ Discovery & Visualization</h3>
        <p>Initial data cleaning, exploratory analysis, rink maps, shot charts, and identifying trends.</p>
        <button onClick={() => navigate('/discovery')}>View Stage 1</button>
      </div>

      {/* PART 2 */}
      <div className="project-step">
        <h3>2️⃣ Binary Classification</h3>
        <p>A logistic regression model predicting goal vs. no-goal outcomes and revealing the key factors that drive scoring probability.</p>
        <button onClick={() => navigate('/binaryclassification')}>View Stage 2</button>
      </div>

      {/* PART 3 */}
      <div className="project-step">
        <h3>3️⃣ Binary Classification Visualization</h3>
        <p>Same as before but with more datasets and visualization.</p>
        <button onClick={() => navigate('/binaryclassificationviz')}>View Stage 3</button>
      </div>

      {/* PART 4 */}
      {/* <div className="project-step">
        <h3> 6️⃣Model Enhancements</h3>
        <p>Improving model accuracy with feature engineering, tuning, and shot context variables.</p>
        <button onClick={() => navigate('/enhancements')}>View Stage 4</button>
      </div> */}

      {/* PART 5 */}
      <div className="project-step">
        <h3>4️⃣ Team-level Data Clustering</h3>
        <p>  We use MoneyPuck’s 5-on-5 team data with PCA and K-Means to uncover NHL team
  playing styles.</p>
        <button onClick={() => navigate('/clustering')}>View Stage 5</button>
      </div>
            <div className="project-step">
        <h3> 5️⃣Player Finishing Analysis</h3>
        <p>  Using five seasons of MoneyPuck shot data, we evaluate NHL player finishing by
  comparing actual goals to expected goals (xG). We identify the league’s best
  and worst finishers and visualize how far individual players perform.</p>
        <button onClick={() => navigate('/finishing')}>View Stage 5</button>
      </div>
    </div>
  </section>


</div>


  );
};

export default Home;

